import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import UsersForm from '../../components/Users/UsersForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-users';

class addUsers extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {

    };
  }


  handleSubmit = (FormData) => {
    this.props.saveUsers(FormData);
  }


  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Users" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit User</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New User</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                <UsersForm onSubmit={this.handleSubmit} />

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addUsers.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveUsers: PropTypes.func
};

addUsers.defaultProps = {
  formLoading: null,
  formError: null,
  saveUsers: null
};

const mapStateToProps = ({ users }) => ({});


const mapDispatchToProps = (dispatch) => ({
  saveUsers: (data) => dispatch(actions.saveUsers(data)),
  setForm: (id) => dispatch(actions.editUsers(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addUsers);
